import { create } from 'zustand';

interface ChatStore {
  open: boolean;
  medicoId: string | null;
  openChat: (medicoId: string) => void;
  closeChat: () => void;
  goBack: () => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  open: false,
  medicoId: null,
  openChat: (medicoId) => set({ open: true, medicoId }),
  closeChat: () => set({ open: false, medicoId: null }),
  goBack: () => set({ medicoId: null }),
}));
